// extracted by mini-css-extract-plugin
export default {"headerTitle":"Header_headerTitle__9DNlG","headerLink":"Header_headerLink__jRe6+"};